export default __webpack_public_path__ + "static/media/icons8-hand-holding-heart-100.394c5998.svg";